import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarSeparator,
} from '@polyai/ui/components/organisms/Sidebar';

const SkeletonRow = ({ height = 'h-[36px]' }: { height?: string }) => (
  <div
    className={`flex ${height} items-center gap-xs2 rounded-small px-xs2 group-data-[collapsible=icon]:px-xs3`}
  >
    <div className="size-sm2 shrink-0 rounded-xSmall bg-sidebar-accent" />
    <div className="h-sm1 w-[60%] rounded-xSmall bg-sidebar-accent group-data-[collapsible=icon]:hidden" />
  </div>
);

const ProjectSidebarSkeleton = () => {
  return (
    <Sidebar collapsible="icon">
      <div className="flex h-full flex-col animate-[sidebar-shimmer_2s_ease-in-out_infinite]">
        <SidebarHeader className="gap-0 p-0">
          <div className="flex h-[68px] items-center gap-xs2 px-sm1 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-0">
            <div className="size-sm3 shrink-0 rounded-full bg-sidebar-accent group-data-[collapsible=icon]:hidden" />
            <div className="h-sm1 w-[80px] rounded-xSmall bg-sidebar-accent group-data-[collapsible=icon]:hidden" />
            <div className="ml-auto size-sm1 shrink-0 rounded-xSmall bg-sidebar-accent group-data-[collapsible=icon]:ml-0" />
          </div>

          <SidebarSeparator className="mx-0" />

          <div className="mb-xs2 mt-sm2 flex h-sm3 items-center gap-xs2 px-sm1 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:px-0">
            <div className="hidden size-sm3 shrink-0 rounded-small bg-sidebar-accent group-data-[collapsible=icon]:block" />
            <div className="h-xs3 w-[100px] rounded-xSmall bg-sidebar-accent group-data-[collapsible=icon]:hidden" />
          </div>

          <SidebarMenu className="px-xs2 py-xs2">
            <SidebarMenuItem>
              <SkeletonRow height="h-sm4" />
            </SidebarMenuItem>
          </SidebarMenu>
          <SidebarSeparator className="mx-0 mb-sm2" />
        </SidebarHeader>

        <SidebarContent>
          {/* Home */}
          <SidebarGroup className="py-0">
            <SidebarMenu>
              <SidebarMenuItem>
                <SkeletonRow />
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroup>

          {/* Analytics, Build, Channels, Configure — collapsible group headers */}
          {['analytics', 'build', 'channels', 'configure'].map(section => (
            <SidebarGroup className="py-0" key={section}>
              <SidebarMenu>
                <SidebarMenuItem>
                  <SkeletonRow />
                </SidebarMenuItem>
              </SidebarMenu>
            </SidebarGroup>
          ))}

          <SidebarSeparator className="mx-xs2 my-xs2" />

          {/* Operations */}
          <SidebarGroup className="py-0">
            <SidebarMenu>
              <SidebarMenuItem>
                <SkeletonRow />
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroup>
        </SidebarContent>

        <SidebarFooter className="p-0">
          <SidebarSeparator className="mx-0" />
          <SidebarMenu className="px-xs2 py-xs3">
            <SidebarMenuItem>
              <SkeletonRow />
            </SidebarMenuItem>
            <SidebarMenuItem>
              <SkeletonRow />
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarFooter>
      </div>
    </Sidebar>
  );
};

export default ProjectSidebarSkeleton;
